/*
 * Perspective tables
 */
//import { pathOr } from 'ramda';
//import { bus } from '@/store/bus';
import csvData from '@/data/goals.csv?raw';
import perspective from 'https://cdn.jsdelivr.net/npm/@finos/perspective/dist/cdn/perspective.js';

const MOVIES_URL = 'https://vega.github.io/editor/data/movies.json';

class PerspectiveTables {
  constructor() {
    // eslint-disable-next-line
    this.worker = null;
    this.table = null;
    this.tables = {};
  }

  async getWorker() {
    if (this.worker) {
      return this.worker;
    }
    this.worker = await perspective.worker();
    return this.worker;
  }

  async getTable(tableName) {
    if (tableName in this.tables) {
      return this.tables[tableName];
    }
    let t = null;
    switch (tableName) {
      case 'movies': {
        t = await this.initMoviesTable();
        break;
      }
      case 'csv': {
        t = await this.initCsvTable();
        break;
      }
    }
    this.tables[tableName] = t;
    return t;
  }

  // TEMP, just for testing TODO remove
  async initMoviesTable() {
    const request = fetch(MOVIES_URL);
    const response = await request;
    const json = await response.json();
    for (const row of json) {
      row['Release Date'] = row['Release Date'] ? new Date(row['Release Date']) || null : null;
    }
    const SCHEMA = {
      Title: 'string',
      'US Gross': 'float',
      'Worldwide Gross': 'float',
      'US DVD Sales': 'float',
      'Production Budget': 'float',
      'Release Date': 'date',
      'MPAA Rating': 'string',
      'Running Time min': 'integer',
      Distributor: 'string',
      Source: 'string',
      'Major Genre': 'string',
      'Creative Type': 'string',
      Director: 'string',
      'Rotten Tomatoes Rating': 'integer',
      'IMDB Rating': 'float',
      'IMDB Votes': 'integer',
    };
    const worker = await this.getWorker();
    const table = await worker.table(SCHEMA);
    table.update(json);
    return table;
  }

  async initCsvTable() {
    // Try to init with CSV Infer schema from CSV
    const worker = await this.getWorker();
    const table = await worker.table(csvData);
    //table.update(json);
    return table;
  }
}

const perspectiveTables = new PerspectiveTables();
export { perspectiveTables };
